export const RecipeListingSortByEnum = {
  Description: 0,
  RecipeId: 1,
};

export const RecipeListingReportTypeEnum = {
  NutrientsDetail: 0,
  NutrientsSummary: 1,
  ComponentSummary: 2,
};



// WEBPACK FOOTER //
// ./src/pages/recipelisting/helpers/Constants.js